import GET_ALL_CUSTOMERS from "../graphql/allCustomers.gql";
import GET_ALL_CUSTOMERS_FILTER from "../graphql/customerFilter.gql";
import { apolloClient } from "./apollo";
import ADDRESS_FORM from "../graphql/addressForm.gql";
/**
 * This is only mock api
 *
 */
export const CUSTOMERS = GET_ALL_CUSTOMERS;
export const CUSTOMERS_FILTER = GET_ALL_CUSTOMERS_FILTER;
export function getCustomers(cardCode = "", userId = "") {
  return apolloClient.mutate({
    fetchPolicy: "no-cache",
    mutation: GET_ALL_CUSTOMERS,
    variables: {
      cardCode: cardCode ? cardCode : "",
      userId: userId ? userId : "",
    },
    update: (cache, { data: { customerByCardCodeData } }) => {
      console.log(customerByCardCodeData);
    },
  });
}
export function getCustomerFilter(
  searchField = "",
  cardCode = "",
  userText = "",
  pageSize = "",
  countryFilter = "",
  stateFilter = "",
  currentPage = "",
  countPage = ""
) {
  return apolloClient.mutate({
    fetchPolicy: "no-cache",
    mutation: GET_ALL_CUSTOMERS_FILTER,
    variables: {
      searchField: searchField ? searchField : "",
      cardCode: cardCode ? cardCode : "",
      userText: userText ? userText : "",
      pageSize: pageSize ? pageSize : "12",
      countryFilter: countryFilter ? countryFilter : "",
      stateFilter: stateFilter ? stateFilter : "",
      currentPage: currentPage ? currentPage : "1",
      countPage: countPage ? countPage : "",
    },
    update: (cache, { data: { customerByFilterCollection } }) => {
      console.log(customerByFilterCollection);
    },
  });
}
export function setAddressForm(form, cardCode, customerId) {
  debugger;
  if (!window.navigator.onLine) return "";
  return apolloClient.mutate({
    mutation: ADDRESS_FORM,
    fetchPolicy: "no-cache",
    variables: {
      customerId: customerId,
      addressId: form.addressId ? form.addressId : "",
      addressName: form.addressName.toUpperCase(),
      city: form.city,
      street: form.street,
      postCode: form.postcode,
      country: form.country,
      cardCode: cardCode,
      codeGRS: form.codeGrs ? form.codeGrs : "",
      nameGRS: form.nameGrs ? form.nameGrs : "",
      phone: form.phone ? form.phone : "",
      emailAddress: form.email ? form.email : "",
    },
  });
}

export function addAddressForm(form) {
  if (!window.navigator.onLine) return "";
  return apolloClient.mutate({
    mutation: ADDRESS_FORM,
    fetchPolicy: "no-cache",
    variables: {
      addressName: form.addressName.toUpperCase(),
      city: form.city,
      street: form.street,
      postCode: form.postCode,
      codeGrs: form.codeGrs,
      nameGrs: form.nameGrs,
      phone: form.phone,
      emailAddress: form.emailAddress,
      cardCode: "",
    },
  });
}
